import { render, staticRenderFns } from "./chatMain.vue?vue&type=template&id=1fb3c1d4&scoped=true"
import script from "./chatMain.vue?vue&type=script&lang=js"
export * from "./chatMain.vue?vue&type=script&lang=js"
import style0 from "./chatMain.vue?vue&type=style&index=0&id=1fb3c1d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb3c1d4",
  null
  
)

export default component.exports